import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-stone-100 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <img
                src="https://public.readdy.ai/ai/img_res/3f116279-fda4-4433-96b4-be34229c7c09.png"
                alt="Alfa Çilingir Logo"
                className="h-12 w-auto object-contain"
              />
            </Link>
            <p className="text-gray-500 text-sm leading-relaxed">
              İstanbul Avrupa Yakası'nda 7/24 profesyonel çilingir hizmeti. Beylikdüzü, Esenyurt, Büyükçekmece ve Bahçeşehir'de hızlı çözüm.
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="https://instagram.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-orange-500 text-white rounded-full cursor-pointer hover:bg-orange-600 transition-colors">
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="nofollow noopener noreferrer" className="w-9 h-9 flex items-center justify-center bg-orange-500 text-white rounded-full cursor-pointer hover:bg-orange-600 transition-colors">
                <i className="ri-facebook-fill text-base"></i>
              </a>
            </div>
          </div>

          {/* Hizmetler */}
          <div>
            <h4 className="font-bold text-gray-800 uppercase text-xs tracking-widest mb-4">
              <a href="/hizmetler">Hizmetler</a>
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/hizmetler/acil-kapi-acma" className="hover:text-orange-500 transition-colors cursor-pointer">Acil Kapı Açma</Link></li>
              <li><Link to="/hizmetler/kilit-degistirme" className="hover:text-orange-500 transition-colors cursor-pointer">Kilit Değiştirme</Link></li>
              <li><Link to="/hizmetler/celik-kapi-acma" className="hover:text-orange-500 transition-colors cursor-pointer">Çelik Kapı Açma</Link></li>
              <li><Link to="/hizmetler/oto-cilingir" className="hover:text-orange-500 transition-colors cursor-pointer">Oto Çilingir</Link></li>
              <li><Link to="/hizmetler/kasa-acma" className="hover:text-orange-500 transition-colors cursor-pointer">Kasa Açma</Link></li>
              <li><Link to="/hizmetler/anahtar-kopyalama" className="hover:text-orange-500 transition-colors cursor-pointer">Anahtar Kopyalama</Link></li>
            </ul>
          </div>

          {/* Bölgeler */}
          <div>
            <h4 className="font-bold text-gray-800 uppercase text-xs tracking-widest mb-4">
              <a href="/hizmet-bolgeleri">Hizmet Bölgeleri</a>
            </h4>
            <ul className="space-y-2 text-sm text-gray-500">
              <li><Link to="/hizmet-bolgeleri" className="hover:text-orange-500 transition-colors cursor-pointer">Beylikdüzü Çilingir</Link></li>
              <li><Link to="/hizmet-bolgeleri" className="hover:text-orange-500 transition-colors cursor-pointer">Esenyurt Çilingir</Link></li>
              <li><Link to="/hizmet-bolgeleri" className="hover:text-orange-500 transition-colors cursor-pointer">Büyükçekmece Çilingir</Link></li>
              <li><Link to="/hizmet-bolgeleri" className="hover:text-orange-500 transition-colors cursor-pointer">Bahçeşehir Çilingir</Link></li>
            </ul>
          </div>

          {/* İletişim */}
          <div>
            <h4 className="font-bold text-gray-800 uppercase text-xs tracking-widest mb-4">
              <a href="/iletisim">İletişim</a>
            </h4>
            <ul className="space-y-3 text-sm text-gray-500">
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-orange-500">
                  <i className="ri-phone-fill"></i>
                </span>
                <a href="tel:05416247982" className="hover:text-orange-500 transition-colors cursor-pointer font-semibold text-gray-700">0541 624 79 82</a>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-orange-500">
                  <i className="ri-map-pin-line"></i>
                </span>
                <span>Beylikdüzü, İstanbul</span>
              </li>
              <li className="flex items-start gap-2">
                <span className="w-5 h-5 flex items-center justify-center mt-0.5 text-orange-500">
                  <i className="ri-time-line"></i>
                </span>
                <span>7/24 Hizmet</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-stone-200 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-gray-400">
          <span>© 2026 Alfa Çilingir. Tüm hakları saklıdır.</span>
          <div className="flex items-center gap-4">
            <Link to="/hakkimizda" className="hover:text-orange-500 transition-colors cursor-pointer">Hakkımızda</Link>
            <Link to="/iletisim" className="hover:text-orange-500 transition-colors cursor-pointer">İletişim</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
